import useLocalStorageState from "use-local-storage-state";
import { IColumn, ITextFieldFormat } from "../interfaces/table";

function useActiveColumns<T>(
  key: string,
  defaultColumns: IColumn<T>[],
  useLocalStorage: boolean = true,
): [
  {
    active: boolean;
    title: string;
    field: T;
    format: ITextFieldFormat;
    todo?: boolean | undefined;
    link?: ((rowData: any) => string) | undefined;
  }[],
  React.Dispatch<React.SetStateAction<T[]>>,
] {
  const [activeColumns, setActiveColumns] = useLocalStorageState(key, {
    defaultValue: defaultColumns.filter((d) => d.active).map((d) => d.field),
  });
  if (!useLocalStorage) {
    return [defaultColumns, () => {}];
  }
  const columns = [...defaultColumns]
    .sort((a, b) => {
      const aIndex =
        activeColumns.indexOf(a.field) > -1
          ? activeColumns.indexOf(a.field)
          : 99999;
      const bIndex =
        activeColumns.indexOf(b.field) > -1
          ? activeColumns.indexOf(b.field)
          : 99999;
      return aIndex - bIndex;
    })
    .map((c) => {
      return { ...c, active: activeColumns.indexOf(c.field) > -1 };
    });
  return [columns, setActiveColumns];
}
export default useActiveColumns;
